export default __webpack_public_path__ + "assets/models/acf7597a5d00b17d9397397e2cf8f936.glb";